// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_1p-7";
export var adjustableWidthBorderHeld = "_1p-8";
export var arrow = "_1p-3";
export var arrowButton = "_1p-4";
export var headerCell = "_1p-0";
export var help = "_1p-2";
export var icon = "_1p-1";
export var iconWrapper = "_1p-6";
export var noBorder = "_1p-b";
export var nonAdjustableWidthBorder = "_1p-9";
export var nonAdjustableWidthBorderHeld = "_1p-a";
export var textButton = "_1p-5";